export default {
    SET_CATEGORIES(state,categories){  state.Categories = categories; },
    SET_PRODUCT_DATA(state,product){  state.product = product},
    SET_ORDER_DATA(state,order){  state.order = order},
    SET_PAYMENT_METHOD(state,paymentMethods){  state.paymentMethods = paymentMethods.map((p)=>({ lable:p.name, value:p.id }))}

}